<button (click)="exportMap()" id="map-export-button" [title]="'BUTTON.EXPORT_MAP' | translate" mat-icon-button>
  <i class="mdi mdi-printer sm" aria-hidden="true"></i>
</button>
